var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55556 0C0.7 0 0 0.7 0 1.55556C0 2.41111 0.7 3.11111 1.55556 3.11111C2.41111 3.11111 3.11111 2.41111 3.11111 1.55556C3.11111 0.7 2.41111 0 1.55556 0ZM1.55556 10.8889C0.7 10.8889 0 11.5889 0 12.4444C0 13.3 0.7 14 1.55556 14C2.41111 14 3.11111 13.3 3.11111 12.4444C3.11111 11.5889 2.41111 10.8889 1.55556 10.8889ZM1.55556 5.44444C0.7 5.44444 0 6.14444 0 7C0 7.85556 0.7 8.55556 1.55556 8.55556C2.41111 8.55556 3.11111 7.85556 3.11111 7C3.11111 6.14444 2.41111 5.44444 1.55556 5.44444Z",
    fill: "#3A434B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.ed2e7c00a1288c5349d8c5aa0ebfc940.svg";
export { ForwardRef as ReactComponent };